import styled from "styled-components";

const RiskSelectorListWrapper = styled.ul`
  margin: 0;
  padding: 0;
  list-style-type: none;
`;

export { RiskSelectorListWrapper };



// WEBPACK FOOTER //
// ./src/workerhome/components/Content/RiskSelectorList/styled.js